<template>
  <div class="dwell-container">
    <top-nav :shrinked="true"/>
    <div ref="topMenu" id="boxFixed" class="menu-top-content" :class="{'menu-fix':isFixed}">
      <div class="menu-top">
        <div class="menu-item" :class="{'menu-active':cateIndex==index}" v-for="(item,index) in cateList" :key="index" @click="cateClick(item,index)">
          {{item.name}}
        </div>
      </div>
    </div>
    <img class="banner page-banner" src="@/assets/dwell/banner.jpg">
    <div class="site-text__content bg-gray" style="padding:65px 8.7%;">
      <h3 class="text-blue site-text__content_h3">住宅业务</h3>
      <div class="site-text__content_desc site-text__content_desc_align_left">
        <p>
          历年来，嘉宏深耕地产，以突破谋精品，从不简单复制，也不盲目扩大，以“只定制·不复制”理念实践因地制宜策略，以产品为纽带，把梦想与城市的未来紧密相连，为客户提供高品质的人居环境和服务体验的产品理念，每一代产品都凝聚了嘉宏人钻精克难的奋斗精神和追求极致的创业精神。
        </p>
        <p>
          从功能改善到品质改善，再到产品品牌超越，嘉宏团队从不放弃对极致的追求，产品涵盖奢阔别墅、花园洋房、精工高层、精品公寓、商务办公等。经过多年打磨，形成住宅版块三大产品系。
        </p>
      </div>
    </div>
    <div ref="targetElement" class="three-cate-content">
        <h2 class="bg-img-title" data-aos="fade-up" data-aos-once="true">
          三大产品系
          <div class="bit-img-title-content">
            <span>PRODUCT DEPARTMENT</span>
          </div>
        </h2>
        <img class="cate-img" :src="require('@/assets/dwell/'+cateList[cateIndex].image)">
        <div class="site-text__content cate-title-content">
          <h3 class="text-blue site-text__content_h3 animate__animated animate__fadeInUp">{{cateList[cateIndex].name}}</h3>
          <div class="cate-subtitle animate__animated animate__fadeInUp">{{cateList[cateIndex].subtitle}}</div>
          <div class="site-text__content_desc site-text__content_desc_align_left animate__animated animate__fadeInUp">
            <p>{{cateList[cateIndex].desc}}</p>
          </div>
        </div>
<!--        <div class="cate-title-content" :class="{'cate-active':cateIndex==index}" v-for="(item,index) in cateList" :key="index">-->
<!--          <div v-if="cateIndex==index">-->
<!--            <h2 class="text-blue animate__animated animate__fadeInUp" >{{item.name}}</h2>-->
<!--            <div class="cate-subtitle">{{item.subtitle}}</div>-->
<!--            <div class="cate-desc">{{item.desc}}</div>-->
<!--          </div>-->
<!--        </div>-->
        <div class="cate-base" v-if="cateIndex == 0">
          <h3 class="text-blue site-text__content_h3">风华系三大标准</h3>
          <div v-if="isMobile" class="NioHouseSection_carousel__xKpry">
            <div class="Carousel_carousel__rSN5L carousel" id="main-carousel">
              <div class="slider3" style="margin-top:20px;width: 100%; opacity: 1;background: #E9E9E9;" dir="ltr">
                <div v-for="(item,index) in baseList" :key="index" style="outline:none;">
                  <div class="cate-base-item">
                    <div style="position:relative;">
                      <img :src="require('@/assets/dwell/' + (index+1) + '.jpg')">
                      <div class="cate-base-title">{{item.name}}</div>
                    </div>
                    <div class="cate-base-item-desc">
                      {{item.desc}}
                    </div>
                  </div>
                </div>
              </div>
              <div class="Carousel_carouselControls__HecEP carouselControls">
                <div class="Carousel_carouselPagination__dClSG carouselPagination">
                    <span v-for="(item,index) in baseList" :key="index"
                          class="Carousel_carouselPaginationItem__g0Rld carouselPaginationItem"
                          :class="{'Carousel_carouselPaginationActive__fh9Dk carouselPaginationActive':baseActive==index}">
                    </span>
                </div>
              </div>
            </div>
          </div>
          <div v-else class="cate-base-content">
              <div v-for="(item,index) in baseList" :key="index" class="cate-base-item">
                <div style="position:relative;">
                  <img :src="require('@/assets/dwell/' + (index+1) + '.jpg')">
                  <div class="cate-base-title">{{item.name}}</div>
                </div>
                <div class="cate-base-item-desc">
                  {{item.desc}}
                </div>
              </div>
          </div>
          <div class="cate-base-desc">
            每一座风华系，都集合了“建筑、室内，景观”的国际国内知名大师团队、德系精工的高标准工艺，
            以及嘉宏始终不变的品质匠心
          </div>
          <h3 class="next-title text-blue site-text__content_h3">六恒科技系统</h3>
        </div>
    </div>
    <div v-if="cateIndex == 0" ref="sixElement" class="six-content bg-gray">
        <div class="six-title-content">
          <div class="bg-text">technology</div>
          <h2 class="six-title">分户式六恒科技系统   引领奢适健康人居</h2>
          <div class="six-desc">嘉宏以科技重新注脚健康人居的定义，风华系智能配备最新一代六恒（恒温、恒湿、恒氧、恒洁、恒静、恒智）“分户式科技系统”，以“户”为单位，较以往“集中式系统”，提升居住性能：系统自主开关、温度自主调节、置换新风系统独立、用能自主。在交付使用后的日子里，嘉宏将严格管理运维系统，提高居住体验，焕新生活方式。</div>
        </div>
        <div class="six-middle-content">
          <div class="six-middle-left">
            <div v-for="(item,index) in sixLeftList" :key="index" class="six-middle-left-item">
              <div>
                <div class="six-middle-left-item-icon">
                  <img :src="require('@/assets/dwell/'+item.icon)">
                  <span>{{item.iconLabel}}</span>
                </div>
                <div class="six-middle-left-item-text">{{item.desc}}</div>
              </div>
              <div class="six-middle-left-p">
                <p>{{item.p1}}</p>
                <p>{{item.p2}}</p>
                <p>{{item.p3}}</p>
              </div>
            </div>
          </div>
          <img class="big-img" src="@/assets/dwell/icon_big.png" alt="">
          <div class="six-middle-left">
            <div v-for="(item,index) in sixRightList" :key="index" class="six-middle-left-item row-reverse">
              <div class="six-icon-mode">
                <div class="six-middle-left-item-icon row-reverse">
                  <img :src="require('@/assets/dwell/'+item.icon)" style="margin-left: 5px;">
                  <span>{{item.iconLabel}}</span>
                </div>
                <div class="six-middle-left-item-text">{{item.desc}}</div>
              </div>
              <div class="six-middle-left-p six-middle-right-p" style="margin-right: 20px;">
                <p>{{item.p1}}</p>
                <p>{{item.p2}}</p>
                <p>{{item.p3}}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="six-middle-bottom">
          <div v-for="(item,index) in middleBottomList" :key="index">
            <div>
              <span class="zh-text">{{item.zhLabel}}</span>
              <span class="en-text text-blue">/{{item.enLabel}}</span>
            </div>
            <div class="middle-bottom-desc">{{item.desc}}</div>
            <img :src="require('@/assets/dwell/'+ item.image)">
          </div>
        </div>
    </div>
    <div class="VehicleSlider_vehicleSliderWrapper__GnfuV">
      <h3 class="text-blue site-text__content_h3">项目概览</h3>
      <p :class="{'VehicleSlider_inView__XTMDy':isMobile}" class="VehicleSlider_description__X5kLf VehicleSlider_vehicleSliderDescription__q6TV0">
        左右滑动查看更多
      </p>
      <div class="VehicleSlider_vehicleSliderInnerWrapper__UOqKE VehicleSlider_inView__XTMDy">
        <div class="Carousel_carousel__rSN5L carousel" id="vehicle-slider">
          <div class="slider1 VehicleSlider_vehicleSlider__f1Hi3" dir="ltr">
            <div v-for="(item,index) in projectsList" :key="index">
              <div class="VehicleSlider_vehicleSliderItem__SIbRI" >
                <picture class="responsive-image--picture">
                  <source :srcset="require('@/assets/dwell/' + item.image.desktop)" media="(max-width: 1023px)">
                  <div style="position: relative;">
                    <img :src="require('@/assets/dwell/' + item.image.desktop)" class="ResponsiveImage_responsiveImage__OVw0A slider-img" draggable="false">
                    <img class="Carousel_Img_Right_Icon" v-if="item.image.icon" :src="require('@/assets/dwell/' + item.image.icon)">
                  </div>
                </picture>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import topNav from '@/components/base/top-nav'
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import $ from 'jquery';
import 'slick-carousel';
// import VueArcText from 'vue-arc-text'
var that = null
export default {
  name: "dwell",
  components:{
    topNav,
    // VueArcText
  },
  data() {
    return {
      arcTextForm: {
        text: '码上看房 点亮理想生活', // 弯曲文字的内容
        arc: 150, // 弯曲的角度
        direction: 1 // 弯曲文字的方向 （向上 或 向下）
      },
      isFixed:false,
      isMobile:false,
      baseActive:0,
      cateIndex: 0,
      cateList: [
        {
          image:'banner_fh.jpg',
          name:'风华系',
          subtitle:'时代先行者的荣耀归处',
          desc:'风华系凝萃了嘉宏高规格的人居技术和工艺，是嘉宏集团秉承核芯城市、极致土地、人文资源、高净值人群集聚的择址观，对城市荣耀生活方式的一次全新理解和演绎。'
        },
        {
          image:'banner_wl.jpg',
          name:'未来系',
          subtitle:'新青年的智慧生活场',
          desc:'基于城市青年族群全新的生活需求，从颜值、功能、社交、空间等多维度，关注青年生活场景，营造活力智慧社区，为未来人居定制生活新方案，致力成为90后Z世代高知人群置业首选。'
        },
        {
          image:'banner_xg.jpg',
          name:'星光系',
          subtitle:'一站式“超级芯”商住综合体',
          desc:'嘉宏集团聚焦“地产+商业”双轮驱动模式，以消费者商业体验为中心，以健康、时尚、人文、社交为核心理念，打造城镇枢纽住宅+购物中心+酒店的多元化城市生活方式，所到之处皆为块内难以复制的“超级芯”流量枢纽。'
        }
      ],
      baseList:[
        {
          image:'',
          name:'地段',
          desc:'秉承“总在城市资源精华处“择址观，即在城市浓厚人文底蕴的主城之上，对城市鼎级资源的占有。'
        },
        {
          image:'',
          name:'艺术',
          desc:'精神上必须有深厚的历史人文底蕴或代表城市文化的延续，审美格局上，必须放眼于民族与世界生活方式上，回归到人们最真实的本心。'
        },
        {
          image:'',
          name:'精工',
          desc:'以“只定制不复制”的世界审美，在规划、园林、建筑、精装等各个层面上，以领先行业标准的要求反复打磨。'
        }
      ],
      sixLeftList:[
        {
          icon:'icon_1.png',
          iconLabel:'恒温',
          desc:'四季如春般的温暖',
          p1:'温度适宜',
          p2:'度场均衡',
          p3:'无风感'
        },
        {
          icon:'icon_2.png',
          iconLabel:'恒湿',
          desc:'温润沁心般的滋养',
          p1:'温度适宜',
          p2:'无惧梅雨季',
          p3:'冬季水润养护'
        },
        {
          icon:'icon_3.png',
          iconLabel:'恒氧',
          desc:'新风湖的温柔呵护',
          p1:'新风湖',
          p2:'高效置换',
          p3:'适配新风'
        }
      ],
      sixRightList:[
        {
          icon:'icon_4.png',
          iconLabel:'恒洁',
          desc:'沐浴森林般的呼吸',
          p1:'健康空气龄',
          p2:'无惧雾霾天',
          p3:'室内微正压'
        },
        {
          icon:'icon_5.png',
          iconLabel:'恒静',
          desc:'静谧之地的私人空间',
          p1:'建筑外围护',
          p2:'静谧感受',
          p3:'健康声环境'
        },
        {
          icon:'icon_6.png',
          iconLabel:'恒智',
          desc:'充盈智慧的舒适生活',
          p1:'智控集成',
          p2:'控制方式多样化',
          p3:'科技体验'
        }
      ],
      middleBottomList:[
        {
          zhLabel:'恒温——四季如歌  温润如春',
          enLabel:'constant temperature',
          desc:'通过毛细管网对顶棚进行供冷供热，顶棚与室内空间进行辐射换热，实现对室内温度的控制调节，冬季控制在约18~22℃，夏季约24~28℃，实现空间温度场均衡、无吹风感，常年保持在让人体舒适的温度范围。',
          image:'a1.jpg',
        },
        {
          zhLabel:'恒湿——舒适滋润 秋天无忧',
          enLabel:'constant humidity',
          desc:'利用双冷源除湿技术和湿膜加湿技术，使室内湿度保持30%~70%，远离夏湿冬干，保持高舒适度，拒绝霉菌滋生;适宜的湿度缓解相关疾病;在秋冬季节干燥的环境让皮肤保持水润。',
          image:'a2.jpg',
        },
        {
          zhLabel:'恒氧——空气清新  新氧常在',
          enLabel:'constant oxygen',
          desc:'每户独立新风机，一小时换气一次，空气持久清新，享受室内鲜氧，可时刻处于“新风湖”包裹中。高效换气可降低室内污染，室内空气流速约0.3米/秒，微风拂面，舒适度高。',
          image:'a3.jpg',
        },
        {
          zhLabel:'恒洁——远离污染  健康呼吸',
          enLabel:'constant clean and tidy',
          desc:'双重高效过滤，保证室外充满 PM2.5 粉尘和污染物的空气不会飘入室内，送入室内新鲜空气；独立单向流新风，避免交叉传播;微正压设计，隔绝污浊空气。',
          image:'a4.jpg',
        },
        {
          zhLabel:'恒静——分离降噪 静谧生活',
          enLabel:'constant quiet',
          desc:'室内为毛细管辐射制冷制热，室内无噪音源，全面降低室内喧嚣，保持室内环境处于低分贝。',
          image:'a5.jpg',
        },
        {
          zhLabel:'恒智——智能居家 一键在握',
          enLabel:'constant intelligentize',
          desc:'全屋智慧控制系统，一键掌控。掌上小程序一键开启智能生活；多屏合一，实现全宅智能控制；可开启离家模式，智慧节能。',
          image:'a6.jpg',
        }
      ],

      fhSliders:[
        {
          image: {
            "desktop": "fh_slider1.jpg",
            "mobile": "fh_slider1.jpg",
            icon:'fh_code_1.png'
          }
        },
        {
          image: {
            "desktop": "fh_slider2.jpg",
            "mobile": "fh_slider2.jpg",
            icon:'fh_code_2.png'
          }
        },
        {
          image: {
            "desktop": "fh_slider3.jpg",
            "mobile": "fh_slider3.jpg",
            icon:'fh_code_3.png'
          }
        },
        {
          image: {
            "desktop": "fh_slider4.jpg",
            "mobile": "fh_slider4.jpg",
            icon:'fh_code_4.png'
          }
        },
        {
          image: {
            "desktop": "fh_slider5.jpg",
            "mobile": "fh_slider5.jpg",
            icon:'fh_code_5.png'
          }
        },
        {
          image: {
            "desktop": "fh_slider6.jpg",
            "mobile": "fh_slider6.jpg",
            icon:'fh_code_6.png'
          }
        }
      ],
      wlSliders:[
        {
          image: {
            "desktop": "wl_slider1.jpg",
            "mobile": "wl_slider1.jpg",
            icon:'wl_code_1.png'
          }
        },
        {
          image: {
            "desktop": "wl_slider2.jpg",
            "mobile": "wl_slider2.jpg",
            icon:'wl_code_2.png'
          }
        }
      ],
      xgSliders: [
        {
          image: {
            "desktop": "xg_slider1.jpg",
            "mobile": "xg_slider1.jpg",
            icon:'xg_code_1.png'
          }
        }
      ],
      projectsList:[]
    }
  },
  watch: {
    // MobileVerification: {
    //   handler(to) {
    //     //处理函数
    //     this.isMobile = to;
    //   },
    //   immediate: true,
    // },
  },
  mounted() {
    that = this
    this.initProject()
    this.initSlider();
    this.resizeEvent();
    window.addEventListener("resize", this.resizeEvent)
    window.addEventListener('scroll', this.handleScroll); // 添加滚动事件监听器
    //执行下一步
    this.$nextTick(() => {
      this.offsetTop = document.querySelector('#boxFixed').offsetTop //吸顶距离顶部的距离
    })

    let isSixMode = this.$route.query.isSixMode
    if(isSixMode){
      console.log("isSixMode==",isSixMode)
      // six-content
      this.isFixed = true
      setTimeout(()=>{
        that.goAnchorParent('.six-content')
      },10)
    }
  },
  methods: {
    /**
     * 监听屏幕变化
     */
    resizeEvent(){
      that.initMinSlider()
    },
    handleScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop; // 获取当前滚动位置
      this.isFixed = scrollTop > this.offsetTop ? true : false//当滚动条大于吸顶距离顶部的距离试,就加上css样式
    },
    initMinSlider(isMobile){
      if(window.innerWidth <= 720){
        if(!this.isMobile){
          this.isMobile = true
          this.$nextTick(()=>{
            $('.slider3').slick({
              arrows: false,
              initialSlide: 0
            });
            $('.slider3').on('afterChange', function pauseSlideShow(event, slick, currentSlide){
              that.baseActive = currentSlide
            });
          })
        }
      }else{
        this.isMobile = false
      }
    },
    /**
     * 三大系切换
     */
    cateClick(item,index){
      this.cateIndex = index
      this.isFixed = true//当滚动条大于吸顶距离顶部的距离试,就加上css样式
      setTimeout(()=>{
        that.goAnchorParent('.three-cate-content')
      },50)
      this.updateSliderData()
    },
    updateSliderData(){
      let dataArr = []
      if(this.cateIndex == 0){
        dataArr = this.projectsList
      }else if(this.cateIndex == 1){
        dataArr = this.wlSliders
      }else{
        dataArr = this.xgSliders
      }


      $(".slider1").slick('removeSlide', null, null, true);
      dataArr.forEach((item,index) => {
       $(".slider1").slick('slickAdd',
            '             <div>' +
            '              <div class="VehicleSlider_vehicleSliderItem__SIbRI">' +
            '                <picture class="responsive-image--picture">' +
            '                  <source srcset="' + require('@/assets/dwell/'+item.image.desktop) + '" media="(max-width: 1023px)">' +
            '                  <div style="position: relative;">' +
            '                     <img src="' + require('@/assets/dwell/'+item.image.desktop) + '" class="ResponsiveImage_responsiveImage__OVw0A slider-img" draggable="false">' +
            '                     <img src="' + require('@/assets/dwell/'+item.image.icon) + '" class="Carousel_Img_Right_Icon">' +
            '                  </div>' +
            '                </picture>' +
            '              </div>' +
            '            </div>'
          );
      })
    },
    initProject(){
      if(this.cateIndex == 0){
        this.projectsList = this.fhSliders
      }else if(this.cateIndex == 1){
        this.projectsList = this.wlSliders
      }else{
        this.projectsList = this.xgSliders
      }
    },
    goAnchorParent(selector){
      var element = document.querySelector(selector);
      var elementPosition = element.getBoundingClientRect().top;
      window.scrollBy({
        top: elementPosition - 88,
        behavior: 'smooth' // 平滑滚动
      });

      // 获取固定导航栏的高度
      // var navBarHeight = document.querySelector('.n-header-3-1').offsetHeight;
      // var menuHeight = document.querySelector('.menu-top-content').offsetHeight;
      // // 计算需要滚动的距离
      // var element = document.querySelector(selector);
      // var top = element.getBoundingClientRect().top - navBarHeight - menuHeight;
      // // 滚动到适当位置
      // window.scrollBy({
      //   top: top,
      //   behavior: 'smooth' // 平滑滚动
      // });

      // document.querySelector(selector).scrollIntoView({
      //   behavior: 'smooth'
      // })
    },
    /**
     * 初始化轮播
     */
    initSlider() {
      this.$nextTick(() => {
        $('.slider1').slick({
          infinite: true,
          arrows: true,
          fade: false,
          initialSlide: 0
        });
      });
    }
  }
}
</script>

<style>
  @import "../../styles/dwell.css";
</style>
